import axios from 'axios';
import VueCookies from 'vue-cookies';
import store from '../store';
import router from '@/router';

const instance = axios.create({
  baseURL: 'https://api.moallem.sch.ir/assets/v1/',
});

instance.interceptors.request.use(config => {
  const token = VueCookies.get("ACCESS-TOKEN");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

instance.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;
    if (!originalRequest) {
      return Promise.reject(error);
    }

    const url = originalRequest.url || '';
    const isAuthEndpoint =
      url.includes('/authenticate/auth/') ||
      url.includes('/authenticate/callback/') ||
      url.includes('/authenticate/refresh/');

    const isAuthError =
      error.response &&
      (error.response.status === 401 ||
        (error.response.status === 403 &&
          (!VueCookies.get("ACCESS-TOKEN") ||
            (error.response.data &&
              typeof error.response.data.detail === 'string' &&
              error.response.data.detail.includes('اعتبارسنجی')))));

    if (isAuthError && !isAuthEndpoint && !originalRequest._retry) {
      const refreshToken = VueCookies.get('__ASSETS-REFRESH-TOKEN');

      if (refreshToken) {
        if (isRefreshing) {
          return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject });
          })
            .then(token => {
              originalRequest.headers.Authorization = `Bearer ${token}`;
              return instance(originalRequest);
            })
            .catch(err => Promise.reject(err));
        }

        originalRequest._retry = true;
        isRefreshing = true;

        try {
          await store.dispatch('getAccessTokenFromRefreshToken');
          const newToken = VueCookies.get('ACCESS-TOKEN');
          processQueue(null, newToken);
          if (newToken) {
            originalRequest.headers.Authorization = `Bearer ${newToken}`;
            return instance(originalRequest);
          }
        } catch (refreshErr) {
          processQueue(refreshErr, null);
          console.error('Refresh token failed:', refreshErr);
        } finally {
          isRefreshing = false;
        }
      }

      // No refresh token or refresh failed -> clean up and redirect to login
      VueCookies.remove('__ASSETS-REFRESH-TOKEN');
      VueCookies.remove('ACCESS-TOKEN');
      if (router.currentRoute.value.name !== 'login') {
        router.push({ name: 'login' });
      }
      return Promise.reject(error);
    }

    if (error.response && error.response.status === 404) {
      router.push({ name: '404' });
    } else if (
      error.response &&
      error.response.status >= 500 &&
      error.response.status <= 600 &&
      !isAuthEndpoint
    ) {
      if (router.currentRoute.value.path.split('/').reverse()[0] !== '500') {
        router.push({ path: router.currentRoute.value.path + '/500' });
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
